import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { Form, Input, message } from 'antd';
import { getTeammatesNotOnProject } from '@gtintel/platform-api';
import { MemberCard } from '@gtintel/platform-molecules';
import { UserRole } from '@gtintel/platform-types';
import { ButtonsContainer, Container, ProjectMemberCard, SearchIcon } from './styles';
import { MembersContainer } from './styles';
const AddMemberToTeamForm = ({
  Buttons,
  onOk,
  teamId,
  project
}, ref) => {
  const projectId = project?.id;
  const [form] = Form.useForm();
  const [team, setTeam] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [selectedUser, setSelectedUser] = useState(undefined);
  const clearForm = () => {
    form.resetFields();
  };
  useImperativeHandle(ref, () => ({
    clearForm
  }));
  const handleChange = useCallback(keyword => {
    setKeyword(keyword.toLowerCase());
  }, []);
  const handleCompleteForm = () => {
    if (selectedUser) {
      const param = {
        client_id: selectedUser
      };
      onOk(param);
    } else {
      message.error('Please select a team member.');
    }
  };
  const handleSelectUser = id => {
    if (selectedUser !== id) {
      setSelectedUser(id);
    } else {
      setSelectedUser(undefined);
    }
  };
  useEffect(() => {
    if (teamId && projectId) {
      getTeammatesNotOnProject(projectId).then(members => setTeam(members));
    }
  }, [projectId]);
  const filteredTeamUsers = useMemo(() => !keyword ? team : team.filter(({
    full_name
  }) => full_name.toLowerCase().includes(String(keyword))), [keyword, team]);
  return <Container>
      <Form form={form} onFinish={handleCompleteForm}>
        <Form.Item name="name">
          <Input value={keyword} placeholder={`Search team members`} onChange={e => handleChange(e.currentTarget.value)} suffix={<SearchIcon />} />
        </Form.Item>
        <MembersContainer>
          {filteredTeamUsers?.map(member => <ProjectMemberCard key={member.id} selected={selectedUser === member.id} onClick={() => handleSelectUser(member.id)}>
              <MemberCard member={member} description={member?.role ? UserRole[member?.role] : 'Role'} />
            </ProjectMemberCard>)}
        </MembersContainer>
        <ButtonsContainer>{Buttons}</ButtonsContainer>
      </Form>
    </Container>;
};
export default forwardRef(AddMemberToTeamForm);